import WriteAnswer from './writeAnswer'

export { WriteAnswer }
